import store from '../store';
import { vue } from '../main';

// Redirect User if no instance is loaded
export default function instanceLoaded({ next, router }) {
  if (!store.getters.instanceLoaded) {
    return router.push({ name: 'home' });
  }

  return next();
}
